import { Injectable } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import * as moment from 'moment';

import { OverlayPage } from '../../components/overlay/overlay.page';
import { ICanActivateOverlays, IDataOverlay } from '../../models/CanActivate';
import { NativeStorageNamesV2 } from '../../models/Constants';
import { FiltroPipe } from '../../pipes/filtro.pipe';
import { AnalyticsService } from '../analytics.service';
import { StorageData } from '../utilities/storage-data.class';

@Injectable({
  providedIn: 'root'
})
export class OverlayService {

  private openOverlay: HTMLIonModalElement = null

  constructor(
    private modal: ModalController
    , private analytcsService: AnalyticsService
    , private nav: NavController
    , private filter: FiltroPipe
  ) { }

  private async openModal(clase: string, overlay: string, params: any, slide: boolean, analyticsScreen?: string) {
    this.openOverlay = await this.modal.create({
      component: OverlayPage
      , mode: 'md'
      , backdropDismiss: false
      , cssClass: clase || 'ion-modal-overlayPage'
      , componentProps: {
        keyStorage: overlay
        , otherParameters: params
        , slide
      }
    })

    await this.openOverlay.present()
    const { data } = await this.openOverlay.onDidDismiss();

    if (analyticsScreen) {
      // ** TODO Migracion: Remplazar envio de evento por GTM
      /*
      this.analytcsService.fbAnalyticsCurrentScreen(analyticsScreen)
      StorageData.getDataStorage(NativeStorageNamesV2.PerfilUsuario)
        .then(userData => {
          if (userData) {
            AllUserValues.forEach(value => {
              this.analytcsService.fbAnalyticsUserPropertys(value, userData[value])
            })
            this.analytcsService.gtmCurrentScreenUser({ pagina: analyticsScreen, event: 'pageView' }, userData)
          }
        })
      */
    }

    return data

  }

  public async reOpenOverlay(clase: string, path: string) {

    const dataOverlys: ICanActivateOverlays[] = await StorageData.getDataStorage(NativeStorageNamesV2.OverlaysModulos)

    if (dataOverlys) {
      const overlayHelp: ICanActivateOverlays = dataOverlys.filter(x => x.Ruta === path)[0]
      if (overlayHelp) {
        return await this.openModal(clase, path, overlayHelp, false)
      }
      return false
    }
  }

  public onDismissOverlay = async () => {
    if (this.openOverlay !== null) {
      return await this.openOverlay.dismiss(true);
    }
    return Promise.resolve(true);
  }

  public async firstTimeOverlay(clase: string, overlay: string, params: ICanActivateOverlays, time: number, analyticsCurrentScreen?: string) {
    let storage: IDataOverlay = await StorageData.getDataStorage(overlay)
    if (!storage) {
      storage = { firstTime: 0, FechaEdicion: params.FechaEdicion }
      StorageData.setDataStorage(overlay, storage)
      setTimeout(async () => {
        const dismis = await this.onDismissOverlay()
        await this.openOverlayDiffer(clase, overlay, params, analyticsCurrentScreen)
      }, time)
      return true
    } else {
      switch (storage.firstTime) {
        case 0:
          setTimeout(async () => {
            const dismis = await this.onDismissOverlay()
            await this.openOverlayDiffer(clase, overlay, params, analyticsCurrentScreen)
          }, time)
          break
        case 1:
          const fecha1 = moment(storage.FechaEdicion)
          const fecha2 = moment(params.FechaEdicion)
          const diff = fecha2.diff(fecha1, 'minutes')
          if (diff > 0) {
            storage = { firstTime: 0, FechaEdicion: params.FechaEdicion }
            StorageData.setDataStorage(overlay, storage)
            setTimeout(async () => {
              const dismis = await this.onDismissOverlay()
              await this.openOverlayDiffer(clase, overlay, params, analyticsCurrentScreen)
            }, time)
          }
          break
      }

      return true

    }

  }

  private async openOverlayDiffer(clase: string, overlay: string, params: ICanActivateOverlays, analyticsCurrentScreen?: string) {
    if (analyticsCurrentScreen) {
      return await this.openModal(clase, overlay, params, false, analyticsCurrentScreen)
    } else {
      return await this.openModal(clase, overlay, params, false)
    }
  }

  public async overlayOpenFotoExito(dataOverlys: ICanActivateOverlays[], path: string) {
    if (dataOverlys) {
      const overlay: ICanActivateOverlays[] = this.filter.transform(dataOverlys, path, 'Ruta')
      const objectOverlay: ICanActivateOverlays = overlay.length > 0 ? overlay[0] : null

      if (objectOverlay) {
        await this.firstTimeOverlay('', path, objectOverlay, 1500)
      }
    }
  }


  public async overlayOpenProducts(segment: number, tipoPromocion: string) {

    const dataOverlys: ICanActivateOverlays[] = await StorageData.getDataStorage(NativeStorageNamesV2.OverlaysModulos);

    await this.onDismissOverlay();

    const url: string = this.nav['router'].url.split('/');
    const ruta = url[url.length - 1].split('/')[0];
    let path = `${ruta}/:${segment}`

    const overlayHelps = dataOverlys.filter(x => x.Ruta === path);
    const overlaysHelpPromo = tipoPromocion === '' ? [] : dataOverlys.filter(x => x.Ruta === tipoPromocion);

    const overlays = overlaysHelpPromo.length > 0 ? overlaysHelpPromo : overlayHelps
    path = tipoPromocion === '' ? path : tipoPromocion;
    if (overlays.length > 0) {
      switch (tipoPromocion) {
        case 'DINAMICO':
          await this.firstTimeOverlaySlide(path, overlays)
          break;
        case 'ESCALERA':
          await this.firstTimeOverlaySlide(path, overlays)
          break;
        case 'ESTATICO':
          await this.firstTimeOverlaySlide(path, overlays)
          break;
        default:
          await this.firstTimeOverlay('', path, overlays[0], 0)
          break;
      }
    }
  }

  public firstTimeOverlaySlide = async (path: string, params: ICanActivateOverlays[]) => {
    let storage: IDataOverlay = await StorageData.getDataStorage(path)
    if (!storage) {
      storage = { firstTime: 0, FechaEdicion: params[0].FechaEdicion }
      StorageData.setDataStorage(path, storage)
      return await this.openModal('', path, params, true)
    } else {
      let retorno;
      switch (storage.firstTime) {
        case 0:
          retorno = await this.openModal('', path, params, true)
          break
        case 1:
          const fecha1 = moment(storage.FechaEdicion)
          const fecha2 = moment(params[0].FechaEdicion)
          const diff = fecha2.diff(fecha1, 'minutes')
          if (diff > 0) {
            storage = { firstTime: 0, FechaEdicion: params[0].FechaEdicion }
            StorageData.setDataStorage(path, storage)
            retorno = await this.openModal('', path, params, true)
          }
          break
      }

      return retorno;

    }

  }

  public async reOpenOverlayProducts(segment: number, tipoPromocion: string) {

    const dataOverlys: ICanActivateOverlays[] = await StorageData.getDataStorage(NativeStorageNamesV2.OverlaysModulos);

    await this.onDismissOverlay();

    const url: string = this.nav['router'].url.split('/');
    const ruta = url[url.length - 1].split('/')[0];
    let path = `${ruta}/:${segment}`;

    const overlaysHelp = dataOverlys.filter(x => x.Ruta === path);
    const overlaysHelpPromo = tipoPromocion === '' ? [] : dataOverlys.filter(x => x.Ruta === tipoPromocion);

    const overlays = overlaysHelpPromo.length > 0 ? overlaysHelpPromo : overlaysHelp
    if (overlays.length > 0) {
      path = tipoPromocion === '' ? path : tipoPromocion;

      switch (tipoPromocion) {
        case 'DINAMICO':
          await this.openModal('', path, overlays, true)
          break;
        case 'ESCALERA':
          await this.openModal('', path, overlays, true)
          break;
        case 'ESTATICO':
          await this.openModal('', path, overlays, true)
          break;
        default:
          await this.openModal('', path, overlays[0], false)
          break;
      }
      return true;
    }
  }

}
